import { render, staticRenderFns } from "./CookieStatement.vue?vue&type=template&id=d423baaa&scoped=true&"
import script from "./CookieStatement.vue?vue&type=script&lang=js&"
export * from "./CookieStatement.vue?vue&type=script&lang=js&"
import style0 from "./CookieStatement.vue?vue&type=style&index=0&id=d423baaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d423baaa",
  null
  
)

export default component.exports